module.exports = __webpack_public_path__ + "static/img/weichat7.e4c5d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/weichat7.png
// module id = vhDw
// module chunks = 1